import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import StageIconSvg from './stage-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <StageIconSvg {...validProps} />;
}
SvgComponent.iconName = 'stageIcon';

export const StageIcon = svgIconWrapper(SvgComponent);
